import React from 'react';
import AdminSpecialPaymentContainer from '../../../Containers/AdminContainer/AdminSpecialPaymentContainer';

const AdminSpecialPaymentScreen = () => {
  return <AdminSpecialPaymentContainer />;
};

export default AdminSpecialPaymentScreen;
